 
import { ScheduleMeetingConstants } from '../interface/schedule-meeting-constants';

export const SCHEDULE_MEETING_CONSTANTS: ScheduleMeetingConstants = {
  timePickerDefaultMin: new Date(2000, 1, 1, 8, 0),
  timePickerDefaultMax: new Date(2000, 1, 1, 20, 0),
  timePickerDefaultValue: new Date(2000, 1, 1, 8, 0),
  SHM_ALLOWED_ADDITIONAL_ATTENDEE_ROLES: [
    'PARENT',
    'SCHOOL SOCIAL WORKERS (MANDATED SERVICES)',
    'TEACHER',
    'PRINCIPAL',
    'SCHOOL PSYCHOLOGIST',
    'CSE CHAIRPERSON',
  ],
  GEN_ED_ALLOWED_ADDITIONAL_ATTENDEE_ROLES: [
    'PARENT',
    'TEACHER',
    'PRINCIPAL',
    'SCHOOL PSYCHOLOGIST',
    'CSE CHAIRPERSON',
  ],
  IEP_ALLOWED_ADDITIONAL_ATTENDEE_ROLES: [
    'PARENT',
    'TEACHER',
    'STUDENT',
    'SCHOOL PSYCHOLOGIST',
    'SCHOOL SOCIAL WORKER',
    'GENERAL EDUCATIONAL TEACHER',
    'TEACHER SPECIAL EDUCATION',
    'RELATED SERVICE PROVIDER',
    'DISTRICT REPRESENTATIVE',
  ],
  EXTERNAL_ROLE: 'EXTERNAL/OTHER',
  PARENT_ROLE: 'PARENT',
  timePickerDefaultGENMin: new Date(2000, 1, 1, 6, 0),
  timePickerDefaultGENMax: new Date(2000, 1, 1, 22, 0),
  serviceProviders: [
    { text: 'Office of Mental Health (OMH)', controlName: 'omh' },
    { text: 'Office for People with Developmental Disabilities (OPWDD)', controlName: 'opwdd' },
    { text: 'Adult Career and Continuing Education Services - Vocational Rehabilitation (ACCES-VR)', controlName: 'accesvr' },
    { text: 'At this time, no agency has been identified to likely be responsible for providing/paying for transition services', controlName: 'none' },
    { text: 'Other', controlName: 'other' }]
};

//Warning Messages:
export const SEVEN_DAYS_BEFORE_REQUIRED_START_DATE: string =
  'You have selected a date that is within 7 days before the required start date. Do you wish to continue?';
export const SIXTY_DAYS_FROM_TODAY_DATE: string =
  'You have selected a date that is more than 60 days from today\'s date. Do you wish to continue?';
export const SIXTY_DAYS_FROM_INITIAL_CONSENT_DATE: string =
  'The IEP Meeting must be held no later than 60 days from the initial consent date. Do you wish to continue?';
export const PAST_DATE: string =
  'You have selected a date that is in the past. Do you wish to continue?';

//Delivery Methods:
export const POSTAL_MAIL: string = 'Postal Mail';

//IEP Meeting Actions:
export const SCHEDULE_MEETING: string = 'Schedule IEP Meeting';
export const RESCHEDULE_MEETING: string = 'Reschedule IEP Meeting';
export const VIEW_NOTICE_MEETING: string = 'View Notice of IEP Meeting';
export const RECONVENE_MEETING: string = 'Reconvene IEP Meeting';
export const AMMEND_IEP: string = 'Amend IEP';
export const CREATE_ANNUAL_IEP_MEETING: string = 'Create Annual IEP Meeting';
export const RECONVENE_IEP_MEETING: string = 'Reconvene IEP Meeting';

//Case Stages:
export const ANNUAL_REVIEW: string = 'Annual Review';
export const REEVALUATION: string = 'Reevaluation';
export const ADDITIONAL_REEVALUATION: string = 'Additional Reevaluation';
export const ADDITIONAL_REEVAL: string = 'Additional Reeval';
export const MANDATED_THREE_YEAR: string = 'Mandated 3 - Year';
export const INITIAL: string = 'Initial';
export const AMMENDMENT: string = 'Amendment';
export const RECONVENE: string = 'Reconvene';

//Menu Titles:
export const SCHEDULE_SOCIAL_HISTORY_MEETING: string =
  'Schedule Social History Meeting';
export const GENERAL_EDUCATION_INTERVENTION_MEETING: string =
  'General Education Intervention Meeting';
export const SCHEDULE_EVALUATIONS_MEETING: string =
  'Schedule Evaluations Meeting';
export const INDIVIDUALIZED_EDUCATION_PLAN_MEETING: string =
  'Individualized Education Plan Meeting';

//Meeting Attendees strings:
export const PRINCIPAL: string = 'principal';
export const REPRESENTATIVE: string = 'representative';
export const CHAIRPERSON: string = 'chairperson';
export const PSYCHOLOGIST: string = 'psychologist';
export const RELATED_SERVICES: string = 'related services';
export const SOCIAL: string = 'social';
export const SPECIAL: string = 'special';
export const TEACHER: string = 'teacher';
export const PARENT: string = 'parent';

//TITLE CODE:
export const SUCPQ: string = 'SUCPQ';

//Student Info Error:
export const STUDENT_INFO_ERROR: string = 'Student profile is null';

//Parent Type:
export enum ParentTypeLabel {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}
